import type { DocumentDetailPayload } from '@Application/Beneficiaries/Documents/Actions/documentFetched';

export type DocumentFieldConfirmedAction = {
	type: 'DOCUMENT_FIELD_CONFIRMED';
	payload: DocumentDetailPayload;
};

export default (payload: DocumentDetailPayload): DocumentFieldConfirmedAction => ({
	type: 'DOCUMENT_FIELD_CONFIRMED',
	payload,
});
